import type { AuthoringAgentPatch, AuthoringVersionPatch, StudioAgentArchetype } from '@/types/aiStudioAgent';

export function hasAgentPatchContent(patch?: AuthoringAgentPatch): patch is AuthoringAgentPatch {
  if (!patch) return false;
  return Object.keys(patch).some((k) => {
    const v = patch[k as keyof AuthoringAgentPatch];
    return typeof v === 'string' && v.trim().length > 0;
  });
}

export function hasVersionPatchContent(patch?: AuthoringVersionPatch): patch is AuthoringVersionPatch {
  if (!patch) return false;
  return Object.keys(patch).some((k) => {
    const v = patch[k as keyof AuthoringVersionPatch];
    if (Array.isArray(v)) return v.length > 0;
    return typeof v === 'string' && v.trim().length > 0;
  });
}

export function applyAuthoringPatches(
  agentPatch: AuthoringAgentPatch | undefined,
  versionPatch: AuthoringVersionPatch | undefined,
  handlers: {
    onApplyAgentPatch?: (patch: AuthoringAgentPatch) => void;
    onApplyVersionPatch?: (patch: {
      contextDefinition?: string;
      successCriteria?: string;
      explainInstructions?: string;
      computeClasses?: AuthoringVersionPatch['computeClasses'];
      archetype?: StudioAgentArchetype | null;
      inputExpected?: AuthoringVersionPatch['inputExpected'];
      outputExpected?: AuthoringVersionPatch['outputExpected'];
    }) => void;
  }
): boolean {
  let applied = false;
  if (hasAgentPatchContent(agentPatch) && handlers.onApplyAgentPatch) {
    handlers.onApplyAgentPatch(agentPatch);
    applied = true;
  }
  if (hasVersionPatchContent(versionPatch) && handlers.onApplyVersionPatch) {
    handlers.onApplyVersionPatch({
      ...versionPatch,
      archetype: versionPatch.archetype as StudioAgentArchetype | null | undefined,
    });
    applied = true;
  }
  return applied;
}
